// extracted by mini-css-extract-plugin
export default {"UpscaleUploadButton":"ImagePreview_UpscaleUploadButton__P+9Ay","UpscaleUploadButtonIcon":"ImagePreview_UpscaleUploadButtonIcon__V3wbK"};